import styled from 'styled-components'

export const MaxWidthContainer = styled.div<{ size?: 'large' | 'small' }>`
  max-width: ${({ size }) =>
    size === 'small' ? 'var(--container-max-width)' : '1600px'};
  margin: 0 auto;
`
